// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconCheckmarkCirlce = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M9.32 17.92h-.05c-.58-.02-1.12-.32-1.44-.8l-2.44-3.46a.753.753 0 01.18-1.05.74.74 0 011.04.18l2.45 3.48c.06.1.15.15.25.15.09 0 .19-.04.25-.12l7.85-9.93c.26-.32.73-.38 1.05-.12.33.26.38.73.12 1.05l-7.84 9.92c-.32.44-.86.7-1.42.7zM24 12c0-6.62-5.38-12-12-12S0 5.38 0 12s5.38 12 12 12 12-5.38 12-12zm-1.5 0c0 5.79-4.71 10.5-10.5 10.5S1.5 17.79 1.5 12 6.21 1.5 12 1.5 22.5 6.22 22.5 12z"
      fill="currentColor"
    />
  );
export default SvgIconCheckmarkCirlce;
